import { createEntityCommentsBlock } from "../entity/createEntityCommentsBlock.jsx";

const KundenEntityCommentsBlock = createEntityCommentsBlock({
  title: "💬 Kommentare",
  draftKeyPrefix: "wt_draft_comment_kunde",
  getApiPaths: (kundenId) => ({
    list: `/kunden/${kundenId}/kommentare`,
    create: `/kunden/${kundenId}/kommentar`,
    update: (id) => `/kunden/${kundenId}/kommentar/${id}`,
    remove: (id) => `/kunden/${kundenId}/kommentar/${id}`,
  }),
  buildCreatePayload: (text) => ({ text }),
  buildUpdatePayload: (text) => ({ text }),
});

export default function KundenBlockKommentare({ kundenId }) {
  return <KundenEntityCommentsBlock entityId={kundenId} />;
}
